import isEqual from 'lodash.isequal';

import { trackEvent } from 'helpers/analytics';
import { useEditContactMutation } from 'services/contacts';

export const useCellEditActions = () => {
  const [editContact] = useEditContactMutation();

  const onCellValueChanged = ({ data, colDef, newValue, oldValue }) => {
    if (colDef.customField && newValue !== oldValue) {
      if (isEqual(newValue, [undefined]) && isEqual(oldValue, [undefined])) {
        return;
      }

      const value = colDef.customField.type === 'single_select' ? newValue.id || null : newValue;

      editContact({
        contactId: data.id,
        values: { customFields: [{ id: colDef.customField.id, value }] },
        ...(data?.options?.queryParams ? { queryParams: data.options.queryParams } : {}),
      })
        .unwrap()
        .then(() => {
          trackEvent('contacts:custom_field:updated', {
            type: colDef.customField.type,
            customFieldId: colDef.customField.id,
          });
        });
    }
  };

  return {
    onCellValueChanged,
  };
};
